import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'
import Button from 'srcReact/components/common2/Button'
import Icon from 'srcReact/components/icons/Icon'

const NotFound = ({
  id, // for onboading display
  title,
  icon,
  button,
  buttonClassName,
  handleClick,
  className,
  containerClassName,
  children
}) => {
  return (
    <div id={id} className={`${styles.notFoundWrapper} ${className}`}>
      <div className={`${styles.container} ${containerClassName}`}>
        {icon && <Icon name={icon} styleModifier={styles.icon} />}
        <div className={styles.title}>{title}</div>
        {button && (
          <Button
            handleClick={handleClick}
            text={button}
            size='large'
            customStyle={`${styles.customButtonStyle} ${buttonClassName}`}
          />
        )}
        {children}
      </div>
    </div>
  )
}

NotFound.propTypes = {
  title: PropTypes.string,
  button: PropTypes.string,
  icon: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  handleClick: PropTypes.func
}

export default NotFound
